module.exports = __webpack_public_path__ + "img/cash.f873189d.png";